module.exports = __webpack_public_path__ + "static/media/carousel_2.122a8040.jpg";